<template>

<app-input-wrapper :slim="slim" :stacked="true" :value="value" :note="note" :label="label" :errored="errored" :class="{'is-errored': errored, 'is-previewing': previewImage}">

	<div class="input-file" v-on:click="onUploadClick">{{ placeholder }}</div>

	<input type="file" ref="upload" v-on:change="onFileSelected" class="input-hidden" />

	<div class="input-preview" v-if="previewImage"><img :src="previewImage" /></div>

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

    mixins: [mixinInput],
    
    props: ['hidePreview'],

	data: function() {

		return {
			preview: false
		}

	},

	computed: {

		previewImage: function() {

			return (this.preview && !this.hidePreview) ? this.preview : this.value

		}

	},

	methods: {

		onUploadClick: function() {

			this.$refs.upload.click()

		},

		onFileSelected: function(e) {

			var file = e.target.files[0]

			this.preview = URL.createObjectURL(file)
			

			var reader = new FileReader()
			reader.readAsDataURL(file)

			reader.onload = function() {

				this.$emit('change', reader.result)

			}.bind(this)

		}

	}

}

</script>

<style scoped>

.input-file {
	border: 1px solid var(--color-grey-light);
	height: 40px;
	line-height: 40px;
	border-radius: 4px;
	transition: all 100ms linear;
	width: 100%;
	font-size: 14px;
	font-weight: 300;
	color: var(--color-grey);
	padding: 0px 10px;
	cursor: pointer;
}

.input.is-previewing .input-file {
	border-radius: 4px 4px 0px 0px;
}

.is-desktop .input-file:hover {
	border-color: var(--color-grey-highlight);
}

.input-hidden {
	display: none;
}

.input-preview {
	border: 1px solid var(--color-grey-light);
	border-top-width: 0px;
	border-radius: 0px 0px 4px 4px;
	max-height: 200px;
	padding: 10px;
}

.input-preview img {
	width: auto;
	max-width: 100%;
	max-height: 178px;
}

</style>